/**
 * A farm-mérőszámok megjelenítési apróságai.
 *
 * A leírót (kulcs, címke, ikon, egység) a backend küldi a `/farm/sessions`
 * válaszában — itt csak az van, ami tisztán felületi döntés.
 */

/**
 * A szűk helyekre rövidített címke.
 *
 * A `label` a játék TELJES angol neve, ami hosszú is lehet („Fragment of
 * Infernal Passage" 28 karakter), és a kártyán vagy a chipen levágódna. Ahol
 * kevés a hely, a `short` megy ki, a teljes név pedig az ikon tooltipjében marad.
 */
export const shortLabel = (metric) => metric?.short || metric?.label || '';
